import { createAction } from 'redux-actions'

export const cleanMyAppointments = createAction('MY_APPOINTMENTS/CLEAN_MY_APPOINTMENTS')
